import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './@main/header/header.component';
import { FooterComponent } from './@main/footer/footer.component';
import { HomeComponent } from './@core/home/home.component';
import { ReqformComponent } from './@core/reqform/reqform.component';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './@core/login/login.component';
import { DeciderComponent } from './@core/decider/decider.component';
import { IndividualformComponent } from './@core/individualform/individualform.component';
import { OrganizeformComponent } from './@core/organizeform/organizeform.component';
import { SubmitpageComponent } from './@core/submitpage/submitpage.component';
import { PlatformComponent } from './@core/platform/platform.component';
import { PlatformLegalComponent } from './@core/platform-legal/platform-legal.component';
import { PlatformLegalOrganizerComponent } from './@core/platform-legal-organizer/platform-legal-organizer.component';
import { ServiceAgreementComponent } from './@core/service-agreement/service-agreement.component';
import { SuccessComponent } from './@core/success/success.component';
import { GstRegistrationComponent } from './@core/gst-registration/gst-registration.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { EventComponent } from './@core/event/event.component';
import { TermsAndConditionsComponent } from './@core/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './@core/privacy-policy/privacy-policy.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from '../app/services/loader.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ReqformComponent,
    LoginComponent,
    DeciderComponent,
    IndividualformComponent,
    OrganizeformComponent,
    SubmitpageComponent,
    PlatformComponent,
    PlatformLegalComponent,
    PlatformLegalOrganizerComponent,
    ServiceAgreementComponent,
    SuccessComponent,
    GstRegistrationComponent,
    EventComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    NgSelectModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
